declare global {
  interface String {
    toCapitalized(): string;
    toPluralized(): string;
  }
}

String.prototype.toCapitalized = function () {
  return this.charAt(0).toUpperCase() + this.slice(1);
};

String.prototype.toPluralized = function () {
  if (this.endsWith("s")) return this as string;

  return this + "s";
}

export { }